module.exports = __webpack_public_path__ + "static/media/teke-arataima.c0bd1b4c.jpg";